import { render, staticRenderFns } from "./UserDropDown.vue?vue&type=template&id=12dbed47&"
import script from "./UserDropDown.vue?vue&type=script&lang=ts&"
export * from "./UserDropDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports